import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiChevronDown } from "react-icons/fi";
import image1 from '../assets/faq1.png';
import image2 from '../assets/faq2.png';
import image3 from '../assets/faq3.png';

const Faqs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Is SRIDANTH safe for children?",
      answer: "Yes! SRIDANTH is formulated with safe, gentle ingredients perfect for kids.",
    },
    {
      question: "What age group is it suitable for?",
      answer: "It's suitable for children aged 3 and above.",
    },
    {
      question: "Are the flavors artificial?",
      answer: "No, we use only natural and kid-friendly flavors.",
    },
    {
      question: "Where can I buy SRIDANTH?",
      answer: "You can purchase it online or at leading stores across India.",
    },
  ];

  return (
<section className="max-w-7xl mx-auto py-16 flex flex-col md:flex-row items-center justify-between gap-8 sm:gap-10 md:gap-12">
  {/* Left Section - FAQs */}
  <motion.div 
    className="w-full md:w-1/2"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    transition={{ duration: 0.6 }}
    viewport={{ once: true }}
  >
    <motion.h2 
      className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#0A1E47] mb-6 sm:mb-8 text-center md:text-left"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      Frequently Asked Questions
    </motion.h2>

    <div className="space-y-4">
      {faqs.map((faq, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          viewport={{ once: true }}
          className="border border-gray-200 rounded-lg shadow-sm overflow-hidden"
        >
          <button
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
            className="w-full flex justify-between items-center text-left px-4 sm:px-6 py-4 text-[#0A1E47] font-medium hover:bg-gray-50 transition hover:shadow-md"
          >
            {faq.question}
            <motion.div
              animate={{ rotate: openIndex === index ? 180 : 0 }}
              transition={{ duration: 0.3 }}
            >
              <FiChevronDown />
            </motion.div>
          </button>
          <AnimatePresence>
            {openIndex === index && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.3 }}
              >
                <div className="px-4 sm:px-6 pb-4 text-gray-600">{faq.answer}</div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      ))}
    </div>
  </motion.div>

  {/* Right Section - Images */}
  <div className="w-full md:w-1/2 flex flex-col items-center relative mt-10 md:mt-0">
    <div className="flex flex-wrap justify-center gap-4 sm:gap-6 md:gap-0 md:space-x-[-40px]">
      <motion.img
        src={image1}
        alt="Child 1"
        className="w-28 h-28 sm:w-36 sm:h-36 md:w-44 md:h-44 object-cover rounded-xl shadow-lg transform rotate-[-8deg] hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        viewport={{ once: true }}
      />
      <motion.img
        src={image2}
        alt="Child 2"
        className="w-28 h-28 sm:w-36 sm:h-36 md:w-44 md:h-44 object-cover rounded-xl shadow-lg transform rotate-[5deg] z-10 border-4 border-white hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true }}
      />
      <motion.img
        src={image3}
        alt="Child 3"
        className="w-28 h-28 sm:w-36 sm:h-36 md:w-44 md:h-44 object-cover rounded-xl shadow-lg transform rotate-[15deg] hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        viewport={{ once: true }}
      />
    </div>

    {/* Decorative Arrow */}
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width="140"
      height="40"
      viewBox="0 0 160 50"
      fill="none"
      className="mt-6"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.5 }}
      viewport={{ once: true }}
    >
      <path
        d="M2 48C50 20 110 20 158 48"
        stroke="#1D4ED8"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M158 48L150 44M158 48L150 52"
        stroke="#1D4ED8"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </motion.svg>
  </div>
</section>

  );
};

export default Faqs;